<template>
  <MultipleChoicesDropdown
    title="Round Type"
    :value="value"
    :show-clear-all="false"
    :single-choice="true"
    :search-enabled="false"
    :choices="actualChoices"
    @change="onChange($event)"
  />
</template>

<script>
import { roundTypeChoicesFnc } from 'services/investment-rounds'
import { mapState } from 'vuex'

export default {
  props: {
    value: {
      type: String,
      default: 'OTHER',
    },
    choices: {
      type: Array,
      default: roundTypeChoicesFnc,
    },
  },
  computed: {
    actualChoices() {
      return this.choices.map((choice) => {
        const help = this.getHelp(choice.value)
        return { help, ...choice }
      })
    },
    ...mapState({
      startup: (s) => s.startupProfile.startup,
    }),
  },
  methods: {
    onChange(choice) {
      // TODO: value === 'OTHER'
      this.$emit('change', choice.value)
    },
    getHelp(roundType) {
      if (this.startup && this.startup.stage) {
        let help = `The type of round has to correspond with your company stage. `
        const types = STAGE_TO_ROUND_TYPE_MAP[this.startup.stage]
        if (types.length > 1) {
          help += `It should be one of: ${types.join(', ')}`
        } else if (types.length === 1) {
          help += `It should be: ${types[0]}`
        }
        return help
      } else {
        return `Please choose company stage first.`
      }
    },
  },
}

const STAGE_TO_ROUND_TYPE_MAP = {
  idea: ['Pre-seed'],
  pre_seed: ['Pre-seed'],
  seed: ['Seed', 'Pre-series A'],
  early_growth: ['Pre-series A', 'Series A'],
  growth: ['Pre-series B', 'Series B'],
  maturity: ['Series C+'],
}
</script>
